import { useFetchQuery } from '../../../__generated__/chirp/com/hubspot/connected/application/status/rpc/frontend/ConnectedStatusGraphQLService.hooks';
export function useAppStatus({
  appId,
  shouldFetch
}) {
  const {
    data,
    loading,
    error
  } = useFetchQuery({
    variables: {
      statusFetchOptions: {
        appIds: appId ? [appId] : []
      }
    },
    skip: !shouldFetch || !appId
  });
  return {
    statusData: data === null || data === void 0 ? void 0 : data.results,
    statusLoading: loading,
    statusError: error
  };
}